import { render } from "./RoleObject.vue?vue&type=template&id=1c337fc2"
import script from "./RoleObject.vue?vue&type=script&lang=js"
export * from "./RoleObject.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__